module.exports = __webpack_public_path__ + "img/taken.2425dde3.svg";